module.exports = __webpack_public_path__ + "static/media/06-hotspot1.d1019f24.png";